import {ClimateHazardsEvolutionGet} from '../../../types/api/assets';

// TODO: mock-up only. Same response for every asset until the BE endpoint is available.
export const climateHazardsEvolutionMock: ClimateHazardsEvolutionGet = {
  't0': [
    {
      'hazard_code': 'FLOOD',
      'i_t0': 0,
    },
    {
      'hazard_code': 'LANDSLIDE',
      'i_t0': 0,
    },
    {
      'hazard_code': 'LIGHTNING',
      'i_t0': 4.71,
    },
    {
      'hazard_code': 'HAILSTORM',
      'i_t0': 4.7,
    },
    {
      'hazard_code': 'COASTALFLOOD',
      'i_t0': 0,
    },
    {
      'hazard_code': 'WIND',
      'i_t0': 2.092848062515259,
    },
    {
      'hazard_code': 'SNOW',
      'i_t0': 0.7930333614349365,
    },
    {
      'hazard_code': 'WINDSTORM',
      'i_t0': 1,
    },
    {
      'hazard_code': 'RAIN',
      'i_t0': 3.2315030097961426,
    },
    {
      'hazard_code': 'CYCLONE',
      'i_t0': 0,
    },
    {
      'hazard_code': 'STORM',
      'i_t0': 4.6638617515563965,
    },
    {
      'hazard_code': 'DROUGHT',
      'i_t0': 4,
    },
  ],
  'near': [
    {
      'hazard_code': 'FLOOD',
      'evos': [
        {
          'ccv': 'pr',
          'i_ssp245_near': 0,
          'i_ssp370_near': 0,
        },
      ],
    },
    {
      'hazard_code': 'LANDSLIDE',
      'evos': [
        {
          'ccv': 'pr',
          'i_ssp245_near': 0,
          'i_ssp370_near': 0,
        },
      ],
    },
    {
      'hazard_code': 'LIGHTNING',
      'evos': [
        {
          'ccv': 'tas',
          'i_ssp245_near': 4.744215327650635,
          'i_ssp370_near': 4.74383686097673,
        },
      ],
    },
    {
      'hazard_code': 'HAILSTORM',
      'evos': [
        {
          'ccv': 'tx40',
          'i_ssp245_near': 4.8088868590860026,
          'i_ssp370_near': 4.849128389084261,
        },
      ],
    },
    {
      'hazard_code': 'COASTALFLOOD',
      'evos': [
        {
          'ccv': 'sfcWind',
          'i_ssp245_near': 0,
          'i_ssp370_near': 0,
        },
        {
          'ccv': 'slr',
          'i_ssp245_near': 0,
          'i_ssp370_near': 0,
        },
      ],
    },
    {
      'hazard_code': 'WIND',
      'evos': [
        {
          'ccv': 'sfcWind',
          'i_ssp245_near': 2.0398100049934627,
          'i_ssp370_near': 2.053701579815542,
        },
      ],
    },
    {
      'hazard_code': 'SNOW',
      'evos': [
        {
          'ccv': 'hdd',
          'i_ssp245_near': 0.6595707358071337,
          'i_ssp370_near': 0.6561937149526255,
        },
      ],
    },
    {
      'hazard_code': 'WINDSTORM',
      'evos': [
        {
          'ccv': 'sfcWind',
          'i_ssp245_near': 0.9746574734823067,
          'i_ssp370_near': 0.9812951148242127,
        },
      ],
    },
    {
      'hazard_code': 'RAIN',
      'evos': [
        {
          'ccv': 'tas',
          'i_ssp245_near': 3.254977942765185,
          'i_ssp370_near': 3.254718279029339,
        },
      ],
    },
    {
      'hazard_code': 'CYCLONE',
      'evos': [
        {
          'ccv': 'sfcWind',
          'i_ssp245_near': 0,
          'i_ssp370_near': 0,
        },
      ],
    },
    {
      'hazard_code': 'STORM',
      'evos': [
        {
          'ccv': 'tas',
          'i_ssp245_near': 4.697741912479277,
          'i_ssp370_near': 4.697367153191663,
        },
      ],
    },
    {
      'hazard_code': 'DROUGHT',
      'evos': [
        {
          'ccv': 'tas',
          'i_ssp245_near': 4.029057603100327,
          'i_ssp370_near': 4.028736187666013,
        },
        {
          'ccv': 'tx40',
          'i_ssp245_near': 4.092669667307236,
          'i_ssp370_near': 4.126917777944052,
        },
        {
          'ccv': 'cdd',
          'i_ssp245_near': 4.477286436469882,
          'i_ssp370_near': 4.562319152505626,
        },
        {
          'ccv': 'ds',
          'i_ssp245_near': 4.181769237603289,
          'i_ssp370_near': 4.183240809409525,
        },
      ],
    },
  ],
  'medium': [
    {
      'hazard_code': 'FLOOD',
      'evos': [
        {
          'ccv': 'pr',
          'i_ssp245_medium': 0,
          'i_ssp370_medium': 0,
        },
      ],
    },
    {
      'hazard_code': 'LANDSLIDE',
      'evos': [
        {
          'ccv': 'pr',
          'i_ssp245_medium': 0,
          'i_ssp370_medium': 0,
        },
      ],
    },
    {
      'hazard_code': 'LIGHTNING',
      'evos': [
        {
          'ccv': 'tas',
          'i_ssp245_medium': 4.753524160177033,
          'i_ssp370_medium': 4.757216716438406,
        },
      ],
    },
    {
      'hazard_code': 'HAILSTORM',
      'evos': [
        {
          'ccv': 'tx40',
          'i_ssp245_medium': 5.062923109752025,
          'i_ssp370_medium': 5.186345789682998,
        },
      ],
    },
    {
      'hazard_code': 'COASTALFLOOD',
      'evos': [
        {
          'ccv': 'sfcWind',
          'i_ssp245_medium': 0,
          'i_ssp370_medium': 0,
        },
        {
          'ccv': 'slr',
          'i_ssp245_medium': 0,
          'i_ssp370_medium': 0,
        },
      
      ],
    },
    {
      'hazard_code': 'WIND',
      'evos': [
        {
          'ccv': 'sfcWind',
          'i_ssp245_medium': 2.03414471734558,
          'i_ssp370_medium': 2.0365036066083806,
        },
      ],
    },
    {
      'hazard_code': 'SNOW',
      'evos': [
        {
          'ccv': 'hdd',
          'i_ssp245_medium': 0.6333962230153303,
          'i_ssp370_medium': 0.6170127929208593,
        },
      ],
    },
    {
      'hazard_code': 'WINDSTORM',
      'evos': [
        {
          'ccv': 'sfcWind',
          'i_ssp245_medium': 0.9719504983562318,
          'i_ssp370_medium': 0.9730776175700202,
        },
      ],
    },
    {
      'hazard_code': 'RAIN',
      'evos': [
        {
          'ccv': 'tas',
          'i_ssp245_medium': 3.2613646774417755,
          'i_ssp370_medium': 3.2638981183488815,
        },
      ],
    },
    {
      'hazard_code': 'CYCLONE',
      'evos': [
        {
          'ccv': 'sfcWind',
          'i_ssp245_medium': 0,
          'i_ssp370_medium': 0,
        },
      ],
    },
    {
      'hazard_code': 'STORM',
      'evos': [
        {
          'ccv': 'tas',
          'i_ssp245_medium': 4.706959557483843,
          'i_ssp370_medium': 4.710615942178725,
        },
      ],
    },
    {
      'hazard_code': 'DROUGHT',
      'evos': [
        {
          'ccv': 'tas',
          'i_ssp245_medium': 4.036963193356291,
          'i_ssp370_medium': 4.040099122240685,
        },
        {
          'ccv': 'tx40',
          'i_ssp245_medium': 4.308870731703851,
          'i_ssp370_medium': 4.413911310368509,
        },
        {
          'ccv': 'cdd',
          'i_ssp245_medium': 4.738565318228981,
          'i_ssp370_medium': 4.913848034772806,
        },
        {
          'ccv': 'ds',
          'i_ssp245_medium': 4.196641732348291,
          'i_ssp370_medium': 4.210610558332518,
        },
      ],
    },
  ],
  'far': [
    {
      'hazard_code': 'FLOOD',
      'evos': [
        {
          'ccv': 'pr',
          'i_ssp245_far': 0,
          'i_ssp370_far': 0,
        },
      ],
    },
    {
      'hazard_code': 'LANDSLIDE',
      'evos': [
        {
          'ccv': 'pr',
          'i_ssp245_far': 0,
          'i_ssp370_far': 0,
        },
      ],
    },
    {
      'hazard_code': 'LIGHTNING',
      'evos': [
        {
          'ccv': 'tas',
          'i_ssp245_far': 4.768603521111142,
          'i_ssp370_far': 4.790917966550093,
        },
      ],
    },
    {
      'hazard_code': 'HAILSTORM',
      'evos': [
        {
          'ccv': 'tx40',
          'i_ssp245_far': 5.454113817966439,
          'i_ssp370_far': 7.234333095385376,
        },
      ],
    },
    {
      'hazard_code': 'COASTALFLOOD',
      'evos': [
        {
          'ccv': 'sfcWind',
          'i_ssp245_far': 0,
          'i_ssp370_far': 0,
        },
        {
          'ccv': 'slr',
          'i_ssp245_far': 0,
          'i_ssp370_far': 0,
        },
      
      ],
    },
    {
      'hazard_code': 'WIND',
      'evos': [
        {
          'ccv': 'sfcWind',
          'i_ssp245_far': 2.024679434262128,
          'i_ssp370_far': 2.026230006621215,
        },
      ],
    },
    {
      'hazard_code': 'SNOW',
      'evos': [
        {
          'ccv': 'hdd',
          'i_ssp245_far': 0.5897696916331668,
          'i_ssp370_far': 0.52486667280744,
        },
      ],
    },
    {
      'hazard_code': 'WINDSTORM',
      'evos': [
        {
          'ccv': 'sfcWind',
          'i_ssp245_far': 0.9674278178745555,
          'i_ssp370_far': 0.9681687089057103,
        },
      ],
    },
    {
      'hazard_code': 'RAIN',
      'evos': [
        {
          'ccv': 'tas',
          'i_ssp245_far': 3.2717105373662716,
          'i_ssp370_far': 3.2870203457734695,
        },
      ],
    },
    {
      'hazard_code': 'CYCLONE',
      'evos': [
        {
          'ccv': 'sfcWind',
          'i_ssp245_far': 0,
          'i_ssp370_far': 0,
        },
      ],
    },
    {
      'hazard_code': 'STORM',
      'evos': [
        {
          'ccv': 'tas',
          'i_ssp245_far': 4.721891203916648,
          'i_ssp370_far': 4.743987061366735,
        },
      ],
    },
    {
      'hazard_code': 'DROUGHT',
      'evos': [
        {
          'ccv': 'tas',
          'i_ssp245_far': 4.049769444680376,
          'i_ssp370_far': 4.068720141443816,
        },
        {
          'ccv': 'tx40',
          'i_ssp245_far': 4.641798994013991,
          'i_ssp370_far': 6.156879230115214,
        },
        {
          'ccv': 'cdd',
          'i_ssp245_far': 5.155397777130787,
          'i_ssp370_far': 6.135974665272541,
        },
        {
          'ccv': 'ds',
          'i_ssp245_far': 4.264677586868861,
          'i_ssp370_far': 4.324060919982664,
        },
      ],
    },
  ],
};
